import { useRef, useState, useEffect } from 'react';

/**
 * Hook for calculating minHeight for response blocks.
 * Returns refs for Box and last user message, and their heights.
 */
export const useCalcMinHeightResponse = () => {
  const boxRef = useRef(null);
  const lastUserMessageRef = useRef(null);
  const [boxInnerHeight, setBoxInnerHeight] = useState(0);
  const [lastUserMessageHeight, setLastUserMessageHeight] = useState(0);

  useEffect(() => {
    const nodeBoxContainer = boxRef.current;
    const nodeLastUserMessage = lastUserMessageRef.current;
    if (!nodeBoxContainer || !nodeLastUserMessage) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === nodeBoxContainer) {
          setBoxInnerHeight(entry.contentRect.height);
        }
        if (entry.target === nodeLastUserMessage) {
          setLastUserMessageHeight(entry.contentRect.height);
        }
      }
    });

    observer.observe(nodeBoxContainer);
    observer.observe(nodeLastUserMessage);

    // Set initial heights
    setBoxInnerHeight(nodeBoxContainer.clientHeight);
    setLastUserMessageHeight(nodeLastUserMessage.clientHeight);

    return () => {
      observer.disconnect();
    };
  }, [boxRef.current, lastUserMessageRef.current]);

  return {
    boxRef,
    lastUserMessageRef,
    minHeight: Math.max(0, boxInnerHeight - lastUserMessageHeight - 32),
  };
};
